if (!customElements.get('roulette-section')) {
    class rouletteSection extends HTMLElement {
        constructor() {
            super();
            let that=this;
            this.apiUrl="https://api.phomemo.com"
           // this.apiUrl="https://phomemo.bingdev.top"

            this.rouletteDom=this.querySelector(".roulette-section")
            this.rouletteContainerDom=this.querySelector(".rouletteContainer")
            this.subPopupTermsCheckEl = this.querySelector('#subPopupTermsCheck');
            this.formContainerDom=this.querySelector(".form-container")
            this.rouletteCodeDom=this.querySelector(".rouletteCode")
            this.rouletteTitleDom=this.querySelector(".rouletteTitle")
            this.copyTextBtnDom=this.querySelector(".copyTextBtn")
            this.isRoulette=this.rouletteDom.getAttribute("data-isRoulette")=='true'?true:false
            this.rouletteId=this.rouletteDom.getAttribute("data-rouletteId")
            this.customerId=this.rouletteDom.getAttribute("data-customerId")
            this.activateUrl=''
            this.submitBtn=this.querySelector("#subPopupSubmitBtn")
            this.phomemoWheel=this.querySelector(".phomemo-wheel")
            this.totalItems = Number(this.phomemoWheel.getAttribute('data-item')); 
            this.subPopupEmailEl = this.querySelector('#subPopupEmail');
            if(this.customerId){
                localStorage.setItem("phomemo_customerId",this.customerId);
            }
            if(localStorage.getItem(`phomemo_lottery_${this.rouletteId}`)){
                this.rouletteCodeDom.innerHTML=localStorage.getItem(`phomemo_lottery_${this.rouletteId}`)
                this.rouletteTitleDom.innerHTML=localStorage.getItem(`phomemo_lottery_${this.rouletteId}_title`)
                this.copyTextBtnDom.setAttribute("onclick", `copyText('${localStorage.getItem(`phomemo_lottery_${this.rouletteId}`)}')`);
                this.isRoulette=true
            }
            this.phomemo_customerId=localStorage.getItem("phomemo_customerId");
            this.rouletteContainerDom.style.display=this.isRoulette? 'block':'none'
            this.formContainerDom.style.display=this.isRoulette? 'none':'block'
            this.turns=Number(this.phomemoWheel.getAttribute('data-turn')); 
            this.submitBtn.addEventListener('click', function() {
              if(event.currentTarget.classList.contains('loading')) return;
              if (!that.subPopupEmailEl.checkValidity()) {
                that.subPopupEmailEl.reportValidity();
                return    
            }
            if(!that.subPopupTermsCheckEl.checkValidity()){
                that.subPopupTermsCheckEl.reportValidity();
                return    
            }
              event.currentTarget.classList.add('loading');
              if(that.phomemo_customerId){
                that.rolletAnFn()
              }else{
                that.createCustomFn(that.subPopupEmailEl.value)
              }
            });
        }
        rolletAnFn(isSendEmail=false){
            this.submitBtn.disabled = true;
            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    "customerId":!isSendEmail?this.phomemo_customerId:'',
                    "activityId":this.rouletteId,
                    "email":isSendEmail?this.subPopupEmailEl.value:''
                })
            };
            fetch(this.apiUrl+'/api/shopify/lottery',config)
            .then((response) => response.json())
            .then(async(response) => {
                this.phomemoWheel.classList.remove('spinning');
                if(response.code==1){
                    this.phomemoWheel.classList.remove('spinning');
                    const code = response.data.code;
                    const title = response.data.title;
                    localStorage.setItem(`phomemo_lottery_${this.rouletteId}`, code);
                    localStorage.setItem(`phomemo_lottery_${this.rouletteId}_title`, title);
                    if(isSendEmail){
                        localStorage.setItem("phomemo_customerId",response.data.customerId);
                        localStorage.setItem("phomemo_subPopupEmail",true);
                    }
                    this.rouletteCodeDom.innerHTML=code
                    this.rouletteTitleDom.innerHTML=title
                    let nowTransformRotate=0;
                    const randomIndex = Number(response.data.index);
                    this.turns=this.turns+this.turns;
                    this.phomemoWheel.style.transition = 'none';
                    this.phomemoWheel.style.transition = '';
                    this.phomemoWheel.style.setProperty('--phomemo-selected-item', randomIndex);
                    this.phomemoWheel.classList.add('spinning');
                    nowTransformRotate=this.turns*360-360*randomIndex/this.totalItems
                    this.phomemoWheel.style.transform = `rotate(${nowTransformRotate}deg)`;
                    this.copyTextBtnDom.setAttribute("onclick", `copyText('${localStorage.getItem(`phomemo_lottery_${this.rouletteId}`)}')`);
                    setTimeout(() => {
                        this.rouletteContainerDom.style.display='block'
                        this.formContainerDom.style.display='none'
                    },1200)
                    
                }else if(response.code==0){
                    this.subPopupEmailEl.parentElement.parentElement.querySelector('.error-message').style.display = "block";
                    this.subPopupEmailEl.parentElement.parentElement.querySelector('.error-message').innerHTML = response.message;
                }
                this.submitBtn.disabled = false;
                this.submitBtn.classList.remove("loading");
            })
        }
        createCustomFn(email){
            const regConfig = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    email:email,
                    tags:'roulette-subscribe',
                    issubscribe:true
                })
            };
            fetch(this.apiUrl+'/api/shopify/custom/customerCreate',regConfig)
            .then((response) => response.json())
            .then(async(response) => {
                if(response.code==1){
                    localStorage.setItem("phomemo_customerId",response.data);
                    localStorage.setItem("phomemo_subPopupEmail",true);
                    this.phomemo_customerId=response.data
                    this.rolletAnFn()
                    await this.SendInviteEmailFn(response.data)   
                }else if(response.code==0){
                    console.log("")
                    let errMsg= response.message
                    if(response.message=='Email has already been taken'){
                        errMsg='Email already exists';
                        this.rolletAnFn(true)
                    }
                    this.subPopupEmailEl.parentElement.parentElement.querySelector('.error-message').style.display = "block";
                    this.subPopupEmailEl.parentElement.parentElement.querySelector('.error-message').innerHTML = errMsg;
                    this.submitBtn.disabled = false;
                    this.submitBtn.classList.remove("loading");
                }else{
                    this.submitBtn.disabled = false;
                    this.submitBtn.classList.remove("loading");
                }
            })
        }
        SendInviteEmailFn(email){
            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    customerId:email,
                })
            };
            return fetch(this.apiUrl+'/api/shopify/custom/SendInviteEmail',config)
            .then(res=>{
                return this.getEmailFn(this.phomemo_customerId)
            })
        }
        getEmailFn(uid){
            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    customerId:uid,
                })
            };
            return fetch(this.apiUrl+'/api/shopify/custom/getActivatEmailUrl',config)
            .then((response) => response.json())
            .then((response) => {
                this.activateUrl=response.data
            })
        }
        activateUrlFn(){
            if(this.activateUrl){
                window.location.href=this.activateUrl
            }
        }
        subEdmFn(customerId){
            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    customerId,
                })
            };
            fetch(this.apiUrl+'/api/shopify/custom/subedm',config)
            .then((response) => response.json())
            .then((response) => {
                if(response.code==1){
                    localStorage.setItem("phomemo_subPopupEmail",true);
                    this.getEmailFn(this.phomemo_customerId)
                }
                this.submitBtn.classList.remove("loading");
                this.stepEl1.style.display = "none";
                this.stepEl2.style.display = "block";
            })
        }
        showCodeConetentFn(){
            this.rouletteCodeDom.innerHTML=localStorage.getItem(`phomemo_lottery_${this.rouletteId}`)
            this.rouletteTitleDom.innerHTML=localStorage.getItem(`phomemo_lottery_${this.rouletteId}_title`)
            this.copyTextBtnDom.setAttribute("onclick", `copyText('${localStorage.getItem(`phomemo_lottery_${this.rouletteId}`)}')`);
            this.rouletteContainerDom.style.display='block'
            this.formContainerDom.style.display='none'
        }
    }
    customElements.define('roulette-section', rouletteSection);
}
     